
import { eoRendererMixin, metaDataMixin } from '~/mixins'

export default {
  mixins: [
    eoRendererMixin,
    metaDataMixin,
  ],
  async asyncData ({ $api, $config, store, error, params: { slug }, route: { path } }) {

    // See if we have a campaign for this slug
    const [
      { data: { items: campaign = [] } = {} },
      { data: { items: campaigns = [] } = {} },
    ] = await Promise.all([
      $api.campaigns.getOneBySlug(slug, { domain: $config.preprEnvironmentDomainMetterdaad, offset: 0, limit: 1 }),
      $api.campaigns.getAll({ domain: $config.preprEnvironmentDomainMetterdaad, offset: 0 }),
    ])

    // Check if we found a valid publication
    if (!campaign || !campaign.length) {
      error({
        context: `Couldn't find campaign: ${slug}.`,
        message: '(404) Project niet gevonden',
        severity: 'info',
        statusCode: 404,
      })
      return false
    }

    const { id, title, ...rest } = campaign[0]
    const otherCampaigns = campaigns.filter(campaign => campaign.id !== id) || []
    const { data: { items: articles = [] } = {} } = await $api.campaigns.getAllNested('articles', id, { domain: $config.preprEnvironmentDomainMetterdaad, offset: 0, limit: 4 })

    // Set breadcrumbs for the page
    store.dispatch('breadcrumbs/set', {
      path,
      eoRoot: true,
      floating: true,
      width: 10,
      items: [
        {
          to: '/programmas/eo-metterdaad',
          label: 'EO Metterdaad',
        },
        {
          label: title,
        },
      ],
    })

    return {
      id,
      title,
      ...rest,
      articles: articles,
      campaigns: otherCampaigns,
    }
  },
  data () {
    return {
      articles: [],
      callToAction: {},
      campaigns: [],
      changedOn: null,
      content: [],
      environmentId: null,
      hero: null,
      heroVideo: null,
      heroVideoStill: null,
      id: null,
      intro: null,
      publishOn: null,
      seo: null,
      slug: null,
      social: null,
      title: null,
    }
  },
}
